<template>
  <v-container v-if="user" fluid>
    <v-card elevation="5">
      <v-card-title class="teal lighten-2 accent-5 white--text">
        <v-row no-gutters class="pa-2">
          <v-col cols="12" md="3" class="mt-4"> Conteos </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              @input="filtrarItems"
              v-model="search"
              append-icon="mdi-magnify"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="5" class="mt-4">
            <v-btn color="white" @click="dialogConteo = true">
              Crear Conteo
              <v-icon class="ml-2">mdi-invoice-text-plus-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="mt-4">
            <v-btn
              :class="[
                {
                  'disabled-button': selectedOption != 'abiertos',
                  'enabled-button': selectedOption === 'abiertos',
                },
                'mr-1',
                'mb-7',
              ]"
              color="gray"
              @click="irA('Conteos')"
            >
              Abiertos y Cerrados
            </v-btn>
            <v-btn
              :class="[
                {
                  'disabled-button': selectedOption != 'archivados',
                  'enabled-button': selectedOption === 'archivados',
                },
                'mr-2',
                'ml-2',
                'mb-7',
              ]"
              color="gray"
              @click="irA('Conteos_Archivados')"
            >
              Archivados
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-tabs v-model="selectedTab" color="teal lighten-3 accent-4" left>
        <v-tab
          v-for="sucursal in itemsSucursalesDisponibles"
          :key="sucursal.sucursal"
        >
          <div>
            {{ sucursal.sucursal }}
          </div>
        </v-tab>
        <v-tab-item
          :disabled="true"
          v-for="(sucursal, index) in itemsSucursalesDisponibles"
          :key="index"
        >
          <v-data-table
            :headers="headers"
            :items="sucursal.conteos"
            :search="search"
            checkbox-color="blue darken-1"
            :footer-props="{
              'items-per-page-text': 'Conteos por página',
              'items-per-page-all-text': 'Todos',
            }"
            :header-props="{ 'sort-by-text': 'Ordenar por' }"
            :item-class="colorFila"
            no-data-text="No se encontraron conteos"
            no-results-text="No se encontraron conteos"
            @click:row="abrirConteoDetalles"
          >
            <template v-slot:[`item.fecha_creacion`]="{ item }">
              {{ formatoFecha(item.fecha_creacion) }}
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ getNombreUsuario(item.usuario) }}
            </template>
            <template v-slot:[`item.acciones`]="{ item }">
              <v-btn
                v-if="item.estado === 'abierto'"
                icon
                color="primary"
                @click.stop="abrirDialogModificar(item)"
              >
                <v-icon class="mr-2">mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="item.estado === 'abierto'"
                icon
                color="error"
                @click.stop="cerrarConteo(item)"
              >
                <v-icon class="mr-2">mdi-lock</v-icon>
              </v-btn>
              <v-btn
                v-if="item.estado === 'cerrado'"
                icon
                color="green"
                @click.stop="abrirConteo(item)"
              >
                <v-icon class="mr-2">mdi-lock-open</v-icon>
              </v-btn>
              <v-btn
                v-if="item.estado === 'abierto' || item.estado === 'cerrado'"
                icon
                color="brown"
                @click.stop="archivarConteo(item)"
              >
                <v-icon class="mr-2">mdi-archive</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
      <v-dialog v-model="dialogConteo" max-width="500px" scrollable>
        <v-card>
          <v-card-title>Ingrese el nuevo conteo</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="nombreConteo"
              label="Nombre del Conteo"
              placeholder="Ingrese el nombre del conteo"
            ></v-text-field>
            <v-text-field
              v-model="referenciaConteo"
              label="Referencia"
              placeholder="Ingrese la referencia del conteo"
            ></v-text-field>
            <v-select
              v-model="sucursalConteo"
              :items="selectedSucursal"
              item-value="value"
              label="Sucursal"
              placeholder="Ingrese la sucursal"
              @change="actualizarAlmacen"
            ></v-select>
            <v-text-field
              v-model="codigoAlmacenConteo"
              label="Codigo Almacen"
              placeholder="Ingrese el codigo del almacen"
            ></v-text-field>
            <v-select v-model="tipoConteo" :items="selectTipos" label="Tipo">
            </v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="enviarConteo">Enviar</v-btn>
            <v-btn color="primary" text @click="dialogConteo = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogModificarConteo" max-width="500px" scrollable>
        <v-card>
          <v-card-title>Ingrese el nuevo conteo</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="selectedConteoID"
              label="ID Conteo"
              :disabled="true"
            ></v-text-field>
            <v-text-field
              v-model="selectedConteoNombre"
              label="Nombre del Conteo"
              placeholder="Ingrese el nombre del conteo"
            ></v-text-field>
            <v-text-field
              v-model="selectedConteoReferencia"
              label="Referencia"
              placeholder="Ingrese la referencia del conteo"
            ></v-text-field>
            <v-text-field
              v-model="selectedConteoCodigoAlmacen"
              label="Codigo Almacen"
              placeholder="Ingrese el codigo del almacen"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="modificarConteo">Enviar</v-btn>
            <v-btn color="primary" text @click="dialogModificarConteo = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogConteoDetalles"
        fullscreen
        transition="dialog-top-transition"
      >
        <v-card>
          <v-card-title>
            Detalles del conteo
            <v-spacer></v-spacer>

            <v-btn
              icon
              color="blue darken-1"
              text
              @click="dialogConteoDetalles = false"
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4">
            <p class="font-weight-bold">ID: {{ detalleID }}</p>
            <p class="font-weight-bold">Nombre: {{ detalleNombre }}</p>
            <p class="font-weight-bold">Referencia: {{ detalleReferencia }}</p>
            <p class="font-weight-bold">Tipo: {{ detalleTipo }}</p>
            <v-checkbox v-model="cambiarTabla" label="Acumulados"> </v-checkbox>
            <div v-if="cambiarTabla">
              <div class="d-flex justify-content-end align-right">
                <v-btn
                  class="mt-4 mb-4 mr-4"
                  color="primary"
                  @click="imprimirConteo2"
                  >Imprimir</v-btn
                >

                <v-btn
                  class="mt-4 mb-4"
                  color="primary"
                  @click="descargarExcel2"
                  >Descargar Excel</v-btn
                >
              </div>
              <v-data-table
                :headers="headersProductosAcumulados"
                :items="itemsSumados"
                :search="search3"
                :footer-props="{
                  'items-per-page-text': 'productos por página',
                  'items-per-page-all-text': 'Todos',
                }"
                :header-props="{ 'sort-by-text': 'Ordenar por' }"
                :item-class="colorFila"
                no-data-text="No se encontraron productos"
                no-results-text="No se encontraron productos"
              >
              </v-data-table>
            </div>
            <div v-if="!cambiarTabla">
              <div class="d-flex justify-space-between align-center">
                <v-btn
                  class="mt-4 mb-4"
                  color="primary"
                  @click="dialogAgregarLote = true"
                  >Agregar lote</v-btn
                >

                <div>
                  <v-btn
                    class="mt-4 mb-4 mr-4"
                    color="primary"
                    @click="imprimirConteo"
                    >Imprimir</v-btn
                  >

                  <v-btn
                    class="mt-4 mb-4"
                    color="primary"
                    @click="descargarExcel"
                    >Descargar Excel</v-btn
                  >
                </div>
              </div>

              <div ref="tablaProductosConteo">
                <v-data-table
                  :headers="headersProductos"
                  :items="itemsProductosConteo"
                  :search="search2"
                  :footer-props="{
                    'items-per-page-text': 'productos por página',
                    'items-per-page-all-text': 'Todos',
                  }"
                  :header-props="{ 'sort-by-text': 'Ordenar por' }"
                  :item-class="colorFila"
                  no-data-text="No se encontraron productos"
                  no-results-text="No se encontraron productos"
                >
                  <template v-slot:[`item.eliminar`]="{ item }">
                    <v-btn
                      color="error"
                      icon
                      @click="abrirDialogoEliminarProducto(item)"
                      small
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.fecha_caducidad`]="{ item }">
                    {{
                      formatoFecha(item.fecha_caducidad) === "Invalid date"
                        ? "N/A"
                        : formatoFecha(item.fecha_caducidad)
                    }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAgregarLote" max-width="500px" scrollable>
        <v-card>
          <v-card-title>Agregar lote</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="codigoProducto"
              label="Codigo Producto"
              placeholder="Ingrese el codigo del producto"
            ></v-text-field>
            <v-btn small color="primary" @click="abrirEscaneoProductos"
              ><v-icon class="mr-2">mdi-barcode-scan</v-icon> Escanear Codigo de
              barras
            </v-btn>
            <v-row>
              <v-col cols="12" md="3">
                <v-checkbox v-model="loteVacio" label="Sin lote"></v-checkbox>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  :disabled="loteVacio"
                  v-model="lote"
                  label="Lote"
                  placeholder="Ingrese el lote"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              v-model="cantidadCapturada"
              label="Cantidad Capturada"
              placeholder="Ingrese la cantidad"
            ></v-text-field>
            <v-row>
              <v-col cols="4">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="date-btn"
                      dense
                      icon
                      :disabled="loteVacio === true"
                      @click="incrementYear"
                      ><v-icon>mdi-plus-circle</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :disabled="loteVacio === true"
                      v-model="year"
                      label="Año"
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="date-btn"
                      dense
                      icon
                      :disabled="loteVacio === true"
                      @click="decrementYear"
                      ><v-icon>mdi-minus-circle</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="date-btn"
                      dense
                      icon
                      :disabled="loteVacio === true"
                      @click="incrementMonth"
                      ><v-icon>mdi-plus-circle</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :disabled="loteVacio === true"
                      v-model="month"
                      label="Mes"
                      type="number"
                      min="1"
                      max="12"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="date-btn"
                      dense
                      icon
                      :disabled="loteVacio === true"
                      @click="decrementMonth"
                      ><v-icon>mdi-minus-circle</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="date-btn"
                      dense
                      icon
                      :disabled="loteVacio === true"
                      @click="incrementDay"
                      ><v-icon>mdi-plus-circle</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :disabled="loteVacio === true"
                      v-model="day"
                      label="Día"
                      type="number"
                      min="1"
                      max="31"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="date-btn"
                      dense
                      icon
                      :disabled="loteVacio === true"
                      @click="decrementDay"
                      ><v-icon>mdi-minus-circle</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="agregarLote">Enviar</v-btn>
            <v-btn color="primary" text @click="dialogAgregarLote = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEliminarProducto" max-width="500px">
        <v-card>
          <v-card-title class="subtitle-1"
            >¿Esta seguro de eliminar el producto:<br />{{
              productoSeleccionadoCodigo + " - " + productoSeleccionadoNombre
            }}?</v-card-title
          >
          <v-card-actions>
            <v-btn
              color="error"
              text
              @click="eliminarProductoConteo(productoSeleccionadoID)"
              >Si, eliminar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="dialogEliminarProducto = false"
              >No</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEscaneo" max-width="500px">
        <v-card>
          <v-card-title>Escanear código de barras</v-card-title>
          <v-card-text>
            <div id="scanner" style="width: 100%"></div>
            <div v-if="codigoEscaneado">
              <p>
                Código escaneado: <strong>{{ codigoEscaneado }}</strong>
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="cerrarEscaneo">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAgregarProductoManual" max-width="400px">
        <v-card>
          <v-card-title>Producto no encontrado</v-card-title>
          <v-card-text>
            <p>
              El código de barras
              <strong>{{ codigoEscaneadoManual }}</strong> no existe en la base
              de datos.<br />
              ¿Desea agregarlo manualmente?
            </p>
            <v-text-field
              v-model="codigoProductoManual"
              label="Código del producto"
              placeholder="Ingrese el código del producto"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="agregarProductoManual"
              >Agregar</v-btn
            >
            <v-btn
              color="grey"
              text
              @click="dialogAgregarProductoManual = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      ItemsConteos: [],
      itemsSucursalesDisponibles: [],
      selectedTab: 0,
      search: "",
      search2: "",
      search3: "",
      dialogConteo: false,
      nombreConteo: "",
      referenciaConteo: "",
      codigoAlmacenConteo: "101",
      sucursalConteo: "Mexicali",
      selectedSucursal: [
        {
          text: "Mexicali",
          value: "Mexicali",
          codigoAlmacenConteo: "101",
        },
        {
          text: "Tijuana",
          value: "Tijuana",
          codigoAlmacenConteo: "11",
        },
        {
          text: "Ensenada",
          value: "Ensenada",
          codigoAlmacenConteo: "18",
        },
        {
          text: "La Paz",
          value: "LaPaz",
          codigoAlmacenConteo: "23",
        },
        {
          text: "Obregon",
          value: "Obregon",
          codigoAlmacenConteo: "16",
        },
        {
          text: "Hermosillo",
          value: "Hermosillo",
          codigoAlmacenConteo: "13",
        },
      ],
      tipoConteo: "",
      usuarios: [],
      dialogModificarConteo: false,
      selectedConteoID: "",
      selectedConteoNombre: "",
      selectedConteoReferencia: "",
      selectedConteoCodigoAlmacen: "",
      conteoSeleccionado: null,
      dialogConteoDetalles: false,
      itemsProductosConteo: [],
      itemsProductosConteoAcumulados: [],
      dialogAgregarLote: false,
      lote: "",
      cantidadCapturada: "",
      codigoProducto: "",
      year: moment().endOf("month").year(),
      month: moment().endOf("month").month() + 1,
      day: moment().endOf("month").date(),
      dialogEliminarProducto: false,
      productoSeleccionadoNombre: "",
      productoSeleccionadoCodigo: "",
      productoSeleccionadoID: "",
      selectedOption: "abiertos",
      loteVacio: false,
      dialogEscaneo: false,
      codigoEscaneado: "",
      dialogAgregarProductoManual: false,
      codigoEscaneadoManual: "",
      codigoProductoManual: "",
      scanner: null,
      detalleID: null,
      detalleNombre: null,
      detalleTipo: null,
      detalleReferencia: null,
      cambiarTabla: false,
      timeoutEscaneo: null,
      scannerKeepAliveInterval: null,
      lastScannerActivity: null,

      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Nombre",
          value: "nombre",
        },
        {
          text: "Tipo",
          value: "tipo",
        },
        {
          text: "Referencia",
          value: "referencia",
        },
        {
          text: "Codigo Almacen",
          value: "codigo_almacen",
        },
        {
          text: "Creado por",
          value: "usuario",
        },
        {
          text: "Fecha de creación",
          value: "fecha_creacion",
        },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],

      headersProductos: [
        {
          text: "Código de producto",
          value: "codigo_producto",
        },
        {
          text: "Nombre del producto",
          value: "nombre_producto",
        },
        {
          text: "Lote",
          value: "lote",
        },
        {
          text: "Fecha de caducidad",
          value: "fecha_caducidad",
        },
        {
          text: "Cantidad",
          value: "cantidad_capturada",
        },
        {
          text: "Existencia AdminPAQ",
          value: "existencia_adminpaq",
        },
        {
          text: "Eliminar",
          value: "eliminar",
        },
      ],

      headersProductosAcumulados: [
        {
          text: "Código de producto",
          value: "codigo_producto",
        },
        {
          text: "Nombre del producto",
          value: "nombre_producto",
        },

        {
          text: "Cantidad",
          value: "cantidad_sumada",
        },
        {
          text: "Existencia AdminPAQ",
          value: "existencia_adminpaq",
        },
      ],

      ordenSucursales: [
        "Mexicali",
        "Tijuana",
        "Ensenada",
        "LaPaz",
        "Obregon",
        "Hermosillo",
      ],
      selectTipos: [
        {
          text: "Inventario",
          value: "inventario",
        },
        {
          text: "Compra",
          value: "compra",
        },
        {
          text: "Entrada Traspaso",
          value: "entrada_traspaso",
        },
        {
          text: "Salida Traspaso",
          value: "salida_traspaso",
        },
        {
          text: "Otro",
          value: "otro",
        },
      ],
    };
  },
  methods: {
    esCodigoProductoDirecto(texto) {
      //si el texto recibido es un texto con coma, tomar el primer valor sera el codigo de producto
      if (texto.includes(",")) {
        texto = texto.split(",")[0];
      }

      if (!texto) return false;

      // Un código de producto típicamente tiene un formato específico
      // Ejemplo: BAYEP279, PRODB123, etc.
      // Normalmente son alfanuméricos, longitud de 6-12 caracteres, sin espacios
      const regexCodigoProducto = /^[A-Z0-9]{4,12}$/i;

      // También verificar que no sea un código de barras típico (números largos)
      const esCodigoBarras = /^\d{8,}$/.test(texto);

      return regexCodigoProducto.test(texto) && !esCodigoBarras;
    },
    async abrirEscaneoProductos() {
      try {
        this.resetearEstadoEscaner();
        this.dialogEscaneo = true;
        this.$nextTick(() => {
          this.iniciarEscaner();
        });
      } catch (e) {
        this.mostrarAlertaSegura(
          "No se pudo acceder a la cámara. Asegúrate de que el navegador tenga permisos para usarla.",
        );
        this.dialogEscaneo = false;
      }
    },

    resetearEstadoEscaner() {
      // Limpiar todos los timeouts
      if (this.timeoutEscaneo) {
        clearTimeout(this.timeoutEscaneo);
        this.timeoutEscaneo = null;
      }

      // Limpiar interval de keep-alive
      if (this.scannerKeepAliveInterval) {
        clearInterval(this.scannerKeepAliveInterval);
        this.scannerKeepAliveInterval = null;
      }

      // Reset de todas las variables de estado
      this.codigoEscaneado = "";
      this.codigoEscaneadoManual = "";
      this.codigoProductoManual = "";
    },
    iniciarEscaner() {
      import("html5-qrcode").then(({ Html5Qrcode }) => {
        if (this.scanner) {
          try {
            this.scanner
              .stop()
              .then(() => {
                this.scanner.clear();
              })
              .catch(() => {});
          } catch (e) {
            // Ignora el error si ya estaba limpio
          }
          this.scanner = null;
        }

        this.scanner = new Html5Qrcode("scanner");
        this.scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: 250 },
          async (decodedText) => {
            try {
              this.lastScannerActivity = Date.now(); // Actualizar actividad
              await this.reproducirSonido();
              let productoApi = null;

              // CASO 1: Verificar si es un código de producto directo (ej: BAYEP279)
              if (this.esCodigoProductoDirecto(decodedText)) {
                //separar el codigo de barrras recibido por coma
                const parts = decodedText.split(",");
                const codigoProductoDirecto = parts[0]; // Primer parte es el código del producto

                this.codigoProducto = codigoProductoDirecto;
                this.cerrarEscaneo();
                return;
              } else {
                const response = await axios.get(
                  `/productos/get_by_codigo_de_barras?codigo_de_barras=${decodedText}`,
                );
                productoApi = response.data;
                if (productoApi) {
                  this.codigoProducto = productoApi.codigo;
                } else {
                  console.log("Producto no encontrado en la API.");
                }
              }
            } catch (error) {
              if (!this.esCodigoProductoDirecto(decodedText)) {
                this.codigoEscaneadoManual = decodedText;
                this.codigoProductoManual = "";
                this.dialogAgregarProductoManual = true;
                this.cerrarEscaneo();
              } else {
                alert(
                  "El codigo escaneado no se encuentra en la lista de productos.",
                );
              }
            }
            this.cerrarEscaneo();
          },
          () => {},
        );

        // Iniciar keep-alive para el scanner
        this.lastScannerActivity = Date.now();
        this.scannerKeepAliveInterval = setInterval(() => {
          const now = Date.now();
          const inactiveTime = now - this.lastScannerActivity;
          // Si ha estado inactivo por más de 2 minutos, reiniciar el scanner
          if (inactiveTime > 120000 && this.scanner) {
            console.log("Reiniciando scanner por inactividad");
            this.restartScanner();
          }
        }, 30000); // Verificar cada 30 segundos
      });
    },

    restartScanner() {
      if (this.scanner) {
        this.scanner
          .stop()
          .then(() => {
            this.scanner.clear();
            this.scanner = null;
            // Reiniciar después de un breve delay
            setTimeout(() => {
              this.iniciarEscaner();
            }, 500);
          })
          .catch(() => {
            // Si falla, intentar reiniciar de todas formas
            setTimeout(() => {
              this.iniciarEscaner();
            }, 500);
          });
      }
    },

    cerrarEscaneo() {
      // Cerrar diálogo
      this.dialogEscaneo = false;

      // Limpiar timeouts pendientes
      if (this.timeoutEscaneo) {
        clearTimeout(this.timeoutEscaneo);
        this.timeoutEscaneo = null;
      }

      // Limpiar interval de keep-alive
      if (this.scannerKeepAliveInterval) {
        clearInterval(this.scannerKeepAliveInterval);
        this.scannerKeepAliveInterval = null;
      }

      // Detener scanner de forma segura
      if (this.scanner) {
        try {
          this.scanner
            .stop()
            .then(() => {
              try {
                this.scanner.clear();
              } catch (e) {
                console.log("Error al limpiar scanner:", e);
              }
              this.scanner = null;
            })
            .catch((e) => {
              console.log("Error al detener scanner:", e);
              // Forzar limpieza
              try {
                this.scanner.clear();
              } catch (clearError) {
                console.log("Error al forzar limpieza:", clearError);
              }
              this.scanner = null;
            });
        } catch (e) {
          console.log("Error general del scanner:", e);
          this.scanner = null;
        }
      }

      // Reset completo después de un breve delay
      setTimeout(() => {
        this.resetearEstadoEscaner();
      }, 500);
    },

    async agregarProductoManual() {
      if (!this.codigoProductoManual) {
        alert("Debe ingresar el código del producto.");
        return;
      }
      try {
        await axios.post(
          `/productos/set_codigo_de_barras?codigo_de_barras=${this.codigoEscaneadoManual}&codigo_producto=${this.codigoProductoManual}`,
        );
        alert("Producto agregado correctamente.");
        this.dialogAgregarProductoManual = false;
        this.codigoEscaneadoManual = "";
        this.codigoProductoManual = "";
        // Opcional: refrescar la lista de productos
      } catch (error) {
        alert("Error al agregar el producto.");
      }
    },
    mostrarAlertaSegura(mensaje) {
      // Para mensajes que no requieren control de duplicados
      this.$nextTick(() => {
        alert(mensaje);
      });
    },

    async getConteosAbiertos() {
      try {
        const response = await axios.get("/conteos/get_abiertos/");
        const data = response.data;
        this.itemsSucursalesDisponibles = this.ordenSucursales
          .filter((nombre) => data[nombre])
          .map((nombre) => ({ sucursal: nombre, conteos: data[nombre] }));
      } catch (error) {
        console.log(error);
      }
    },

    async getProductosConteo() {
      try {
        const response = await axios.get(
          `/conteos/get_lotes_de_conteo/${this.conteoSeleccionado.id}`,
        );
        const data = response.data;
        //ordenar por id ascendente
        this.itemsProductosConteo = data.sort((a, b) => a.id - b.id);
        //console.log("productos", this.itemsProductosConteo);
      } catch (error) {
        console.error(error);
      }
    },

    abrirDialogoEliminarProducto(id) {
      this.dialogEliminarProducto = true;
      this.productoSeleccionadoNombre = id.nombre_producto;
      this.productoSeleccionadoCodigo = id.codigo_producto;
      this.productoSeleccionadoID = id.id;
    },

    async eliminarProductoConteo(id) {
      try {
        axios.delete(`/conteos/delete_lote_conteo?id_lote_conteo=${id}`);
        alert("Lote eliminado con exito");
        this.dialogEliminarProducto = false;
        this.getProductosConteo();
      } catch (error) {
        console.error(error);
      }
    },

    async enviarConteo() {
      try {
        axios.post(
          `/conteos/crear?nombre=${this.nombreConteo}&referencia=${this.referenciaConteo}&codigo_almacen=${this.codigoAlmacenConteo}&sucursal=${this.sucursalConteo}&tipo=${this.tipoConteo}`,
        );
        alert("Conteo creado con exito");
        this.dialogConteo = false;
        this.getConteosAbiertos();
        this.nombreConteo = "";
        this.referenciaConteo = "";
        this.codigoAlmacenConteo = "";
        this.sucursalConteo = "";
        this.tipoConteo = "";
      } catch (error) {
        console.error(error);
      }
    },

    async agregarLote() {
      if (
        this.codigoProducto === "" ||
        this.cantidadCapturada === "" ||
        this.lote === null
      ) {
        alert(
          "El codigo de producto, la cantidad capturada y el lote son obligatorios",
        );
        return;
      }

      try {
        const fechaCaducidad = moment(
          `${this.year}-${this.month}-${this.day}`,
        ).format("YYYY-MM-DD");
        if (
          fechaCaducidad === "" ||
          fechaCaducidad === null ||
          fechaCaducidad === "Invalid date"
        ) {
          const response = await axios.post(
            `/conteos/crear_lote_conteo?id_conteo=${this.conteoSeleccionado.id}&lote=${this.lote}&cantidad_capturada=${this.cantidadCapturada}&codigo_producto=${this.codigoProducto}`,
          );
          if (response.status === 200) {
            console.log("response status", response.status);
            alert("Lote agregado con exito");
            this.dialogAgregarLote = false;
            this.getProductosConteo();
          }
        } else {
          const response = await axios.post(
            `/conteos/crear_lote_conteo?id_conteo=${this.conteoSeleccionado.id}&lote=${this.lote}&cantidad_capturada=${this.cantidadCapturada}&fecha_caducidad=${fechaCaducidad}&codigo_producto=${this.codigoProducto}`,
          );

          if (response.status === 200) {
            console.log("response status", response.status);
            alert("Lote agregado con exito");
            this.dialogAgregarLote = false;
            this.getProductosConteo();
          }
        }
      } catch (error) {
        alert(error.response.data.detail);
      }
    },

    async cerrarConteo(item) {
      try {
        this.selectedConteoID = item.id;
        if (confirm("¿Estas seguro de cerrar el conteo?")) {
          axios.post(`/conteos/cerrar_conteo/${this.selectedConteoID}`);
          alert("Conteo cerrado con exito");
          this.getConteosAbiertos();
        } else {
          console.log("Conteo no cerrado");
        }
      } catch (error) {
        console.error(error);
      }
    },

    archivarConteo(item) {
      try {
        this.selectedConteoID = item.id;
        if (confirm("¿Estas seguro de archivar el conteo?")) {
          axios.post(`/conteos/archivar_conteo/${this.selectedConteoID}`);
          alert("Conteo archivado con exito");
          this.getConteosAbiertos();
        } else {
          console.log("Conteo no archivado");
        }
      } catch (error) {
        console.error(error);
      }
    },

    abrirConteo(item) {
      try {
        this.selectedConteoID = item.id;
        if (confirm("¿Estas seguro de abrir el conteo?")) {
          axios.post(`/conteos/abrir_conteo/${this.selectedConteoID}`);
          alert("Conteo abierto con exito");
          this.getConteosAbiertos();
        } else {
          console.log("Conteo no abierto");
        }
      } catch (error) {
        console.error(error);
      }
    },

    abrirDialogModificar(item) {
      this.dialogModificarConteo = true;
      this.selectedConteoID = item.id;
      this.selectedConteoNombre = item.nombre;
      this.selectedConteoReferencia = item.referencia;
      this.selectedConteoCodigoAlmacen = item.codigo_almacen;
    },

    async modificarConteo() {
      try {
        axios.put(
          `/conteos/modificar_conteo/${this.selectedConteoID}?nombre=${this.selectedConteoNombre}&referencia=${this.selectedConteoReferencia}&codigo_almacen=${this.selectedConteoCodigoAlmacen}`,
        );
        alert("Conteo modificado con exito");
        this.dialogModificarConteo = false;
        this.getConteosAbiertos();
      } catch (error) {
        console.error(error);
      }
    },

    abrirConteoDetalles(item) {
      /*if (item.estado === "cerrado" || item.estado === "archivado") {
        console.warn(
          "Conteo cerrado o archivado, no se pueden ver los detalles.",
        );
      } else {*/
      this.conteoSeleccionado = item;
      this.detalleID = item.id;
      this.detalleTipo = item.tipo;
      this.detalleNombre = item.nombre;
      this.detalleReferencia = item.referencia;
      this.dialogConteoDetalles = true;
      //}
    },

    imprimirConteo() {
      // Construimos una tabla HTML limpia con estilos
      const filas = this.itemsProductosConteo
        .map(
          (item) => `
          <tr>
            <td>${item.codigo_producto}</td>
            <td>${item.nombre_producto}</td>
            <td>${item.lote}</td>
            <td>${
              this.formatoFecha(item.fecha_caducidad) === "Invalid date"
                ? "N/A"
                : this.formatoFecha(item.fecha_caducidad)
            }</td>
            <td>${item.cantidad_capturada}</td>
            <td>${
              item.existencia_adminpaq === null
                ? "Sin existencia"
                : item.existencia_adminpaq
            }</td>
          </tr>
        `,
        )
        .join("");

      const contenido = `
        <html>
          <head>
            <title>Reporte de Conteos</title>
            <style>
              body {
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                margin: 30px;
                color: #333;
              }

              h1 {
                text-align: center;
                color: #1976d2;
                text-transform: uppercase;
                margin-bottom: 20px;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 10px;
              }

              th, td {
                border: 1px solid #ccc;
                padding: 8px 10px;
                text-align: left;
              }

              th {
                background-color: #1976d2;
                color: white;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 13px;
              }

              tr:nth-child(even) {
                background-color: #f9f9f9;
              }

              tr:hover {
                background-color: #e0f7fa;
              }

              @media print {
                @page { margin: 2mm; size: landscape; }
              }
            </style>
          </head>
          <body>
            <h1>Reporte de Conteo #${this.conteoSeleccionado.id} de Productos</h1>
            <table>
              <thead>
                <tr>
                  <th>Código de producto</th>
                  <th>Nombre del producto</th>
                  <th>Lote</th>
                  <th>Fecha de caducidad</th>
                  <th>Cantidad</th>
                  <th>Existencia Adminpaq</th>
                </tr>
              </thead>
              <tbody>
                ${filas}
              </tbody>
            </table>
          </body>
        </html>
      `;

      // Abrimos ventana nueva y enviamos a imprimir
      const ventana = window.open("_blank", "width=900,height=700");
      ventana.document.open();
      ventana.document.write(contenido);
      ventana.document.close();
      ventana.print();
    },

    imprimirConteo2() {
      // Construimos una tabla HTML limpia con estilos
      const filas = this.itemsSumados
        .map(
          (item) => `
          <tr>
            <td>${item.codigo_producto}</td>
            <td>${item.nombre_producto}</td>
            <td>${item.cantidad_sumada}</td>
            <td>${item.existencia_adminpaq}</td>
          </tr>
        `,
        )
        .join("");

      const contenido = `
        <html>
          <head>
            <title>Reporte de Conteos</title>
            <style>
              body {
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                margin: 30px;
                color: #333;
              }

              h1 {
                text-align: center;
                color: #1976d2;
                text-transform: uppercase;
                margin-bottom: 20px;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 10px;
              }

              th, td {
                border: 1px solid #ccc;
                padding: 8px 10px;
                text-align: left;
              }

              th {
                background-color: #1976d2;
                color: white;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 13px;
              }

              tr:nth-child(even) {
                background-color: #f9f9f9;
              }

              tr:hover {
                background-color: #e0f7fa;
              }

              @media print {
                @page { margin: 2mm; size: landscape; }
              }
            </style>
          </head>
          <body>
            <h1>Reporte de Conteo #${this.conteoSeleccionado.id} de Productos</h1>
            <table>
              <thead>
                <tr>
                  <th>Código de producto</th>
                  <th>Nombre del producto</th>
                  <th>Cantidad</th>
                  <th>Existencia Adminpaq</th>
                </tr>
              </thead>
              <tbody>
                ${filas}
              </tbody>
            </table>
          </body>
        </html>
      `;

      // Abrimos ventana nueva y enviamos a imprimir
      const ventana = window.open("_blank", "width=900,height=700");
      ventana.document.open();
      ventana.document.write(contenido);
      ventana.document.close();
      ventana.print();
    },

    async descargarExcel() {
      // Se crea primero el libro de excel
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Conteos de Productos");

      // Se agregan los encabezado de la tabla
      worksheet.columns = [
        { header: "Código de producto", key: "codigo", width: 25 },
        { header: "Nombre del producto", key: "nombre", width: 40 },
        { header: "Lote", key: "lote", width: 15 },
        { header: "Fecha de caducidad", key: "fecha", width: 20 },
        { header: "Cantidad", key: "cantidad", width: 15 },
        {
          header: "Existencia Adminpaq",
          key: "existencia_adminpaq",
          width: 20,
        },
      ];

      // Agregando estilos al encabezado
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF00796B" }, // Verde teal
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      //Agregamos filas de los datos proporcionado de la tabla
      this.itemsProductosConteo.forEach((item) => {
        worksheet.addRow({
          codigo: item.codigo_producto,
          nombre: item.nombre_producto,
          lote: item.lote || "N/A",
          fecha:
            this.formatoFecha(item.fecha_caducidad) === "Invalid date"
              ? "N/A"
              : this.formatoFecha(item.fecha_caducidad),
          cantidad: item.cantidad_capturada,
          existencia_adminpaq: item.existencia_adminpaq,
        });
      });

      // Aplicamos estilos a las filas
      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber !== 1) {
          row.eachCell((cell) => {
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        }
      });

      // Por ultimo exportamos y guardamos el archivo con el nombre deseado
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `Conteo #${this.conteoSeleccionado.id}.xlsx`,
      );
    },

    async descargarExcel2() {
      // Se crea primero el libro de excel
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Conteos de Productos");

      // Se agregan los encabezado de la tabla
      worksheet.columns = [
        { header: "Código de producto", key: "codigo", width: 25 },
        { header: "Nombre del producto", key: "nombre", width: 40 },
        { header: "Cantidad", key: "cantidad_sumada", width: 15 },
        {
          header: "Existencia Adminpaq",
          key: "existencia_adminpaq",
          width: 20,
        },
      ];

      // Agregando estilos al encabezado
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF00796B" }, // Verde teal
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      //Agregamos filas de los datos proporcionado de la tabla
      this.itemsSumados.forEach((item) => {
        worksheet.addRow({
          codigo: item.codigo_producto,
          nombre: item.nombre_producto,
          cantidad_sumada: item.cantidad_sumada,
          existencia_adminpaq: item.existencia_adminpaq,
        });
      });

      // Aplicamos estilos a las filas
      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber !== 1) {
          row.eachCell((cell) => {
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        }
      });

      // Por ultimo exportamos y guardamos el archivo con el nombre deseado
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `Conteo Acumulado #${this.conteoSeleccionado.id}.xlsx`,
      );
    },

    ValidarLote(val) {
      if (!this.loteVacio) {
        this.lote = val;
      }
    },

    async getUsuarios() {
      try {
        const response = await axios.get(`/usuarios/get_usuarios`);
        this.usuarios = response.data.usuarios;
      } catch (error) {
        console.error(error);
        return "Desconocido";
      }
    },

    getNombreUsuario(id) {
      const usuario = this.usuarios.find((u) => u.id === id);
      return usuario ? usuario.nombre : "Desconocido";
    },

    filtrarItems() {
      const busqueda = this.search.toLowerCase();
      return this.itemsSucursalesDisponibles.filter((item) =>
        item.sucursal.toLowerCase().includes(busqueda),
      );
    },

    formatoFecha(fecha) {
      //fecha con moment
      return moment(fecha).format("DD/MM/YYYY");
    },
    irA(ruta) {
      this.$router.push(ruta);
    },
    reproducirSonido() {
      const audio = new Audio(require("@/assets/scanner-check.mp3"));
      audio.play();
    },

    actualizarAlmacen() {
      const almacen = this.selectedSucursal.find(
        (i) => i.value === this.sucursalConteo,
      );
      this.codigoAlmacenConteo = almacen.codigoAlmacenConteo || "";
    },
    incrementYear() {
      this.year += 1;
    },
    decrementYear() {
      this.year -= 1;
    },
    incrementMonth() {
      this.month += 1;
      if (this.month > 12) this.month = 1;
    },
    decrementMonth() {
      this.month -= 1;
      if (this.month < 1) this.month = 12;
    },
    incrementDay() {
      this.day += 1;
      if (this.day > 31) this.day = 1;
    },
    decrementDay() {
      this.day -= 1;
      if (this.day < 1) this.day = 31;
    },
  },
  computed: {
    ...mapGetters(["user", "currentUser"]),
    colorFila() {
      return function (item) {
        if (item.estado === "abierto") {
          return "green lighten-4";
        }
        if (item.estado === "archivado") {
          return "yellow lighten-4";
        }
        if (item.estado === "cerrado") {
          return "blue lighten-4";
        }
      };
    },

    itemsSumados() {
      const agrupado = this.itemsProductosConteo.reduce((acc, item) => {
        if (!acc[item.codigo_producto]) {
          acc[item.codigo_producto] = {
            codigo_producto: item.codigo_producto,
            nombre_producto: item.nombre_producto,
            cantidad_sumada: 0,
            existencia_adminpaq: item.existencia_adminpaq,
            index_ultimo: item.index || 0,
            count: 0,
          };
        }
        acc[item.codigo_producto].cantidad_sumada += item.cantidad_capturada;
        acc[item.codigo_producto].existencia_adminpaq;
        acc[item.codigo_producto].count += 1;

        return acc;
      }, {});
      return Object.values(agrupado);
    },
  },
  watch: {
    conteoSeleccionado: {
      handler(nuevoConteo) {
        if (nuevoConteo && nuevoConteo.id) {
          this.getProductosConteo();
        }
      },
      inmediate: true,
    },
    obtenerCodigoPorSucursal(val) {
      if (val === "Mexicali") {
        this.codigoAlmacenConteo = "101";
      }
    },

    loteVacio(val) {
      if (val) {
        this.lote = "NA";
        this.year = "";
        this.month = "";
        this.day = "";
      } else {
        this.lote = "";
        this.year = moment().endOf("month").year();
        this.month = moment().endOf("month").month() + 1;
        this.day = moment().endOf("month").date();
      }
    },
  },
  mounted() {
    this.getConteosAbiertos();
    this.getUsuarios();
  },
  async created() {},
  beforeDestroy() {},
  components: {},
};
</script>

<style scoped>
.date-btn {
  margin: 0px 0px 0px 0px !important;
}
</style>
